import { useDispatch, useSelector } from "react-redux";
import "./fhsgraph.scss";
import { useState, useEffect, useRef } from "react";
import exportimages from "../../../../../../assets/images/exportImages";
import GaugeChart from "./GaugeChart";
import { setShowGaugeChart } from "../../../../../../rtk-query/features/dashboard/financialHealthScore/financialHealthScoreAnalysisSlice";
import { BPM_KEY, PDF_EWI_Image_array } from "../../../../../../utils/global";
import {
  setLoaderFalse,
  setLoaderTrue,
} from "../../../../../../Redux/loaderSlice";
import ForecastGraph from "./ForecastGraph";
// import { Margin } from "react-to-pdf";
// import { useNavigate, useParams } from "react-router-dom";
import { pdf } from "@react-pdf/renderer";
import FinancialHealthScoreDetailsPDF, { PDFstyles } from "./FinancialHealthScoreDetailsPDF";
import {
  convertInnerHTMLToBase64,
  getBase64FromSource,
  transformBankName,
} from "../../../../../../utils/Utils";
import { generateSegmentInfluencingData } from "./SegmentInfluencingSection";
import { generateAllSegmentData } from "./AllSegmentsSection";
import { useNavigate } from "react-router-dom";
import { setChartImage } from "../../../../../../rtk-query/features/chartImage/chartImageSlice";
const FHSGraph = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const orgReducer = useSelector((state) => state.orgReducer);
  const selectedbankMetrics = useSelector(
    (state) => state.infiniteBankPerformanceMetricsReducer,
  );
  let selectedFinancialTrend =
    // selectedbankMetrics?.selectedBankMetricData?.ungroupedResult
    //   ?.financial_health_score;

    selectedbankMetrics?.selectedBankMetricData?.financial_health_score; //New code - 28/05/2025

  const chartRef = useRef(null);
  // const [segmentInfluencingObj, setSegmentInfluencingObj] = useState(null);
  // const [allSegments, setAllSegments] = useState(null);
  // const [updatedEWIdata, setUpdatedEWIdata] = useState(null);

  useEffect(() => {
    // getDownloadReportStatus();
    return () => dispatch(setShowGaugeChart(false));
  }, []);

  //   useEffect(async() => {
  //     debugger
  //    const base64Chart = await getBase64FromSource(".graph-container");
  //     if (base64Chart) dispatch(setChartImage(base64Chart));
  // }, []);

  // State to track whether FHSTrendGraph or FHSGauge is shown
  const [toggleButton, setToggleButton] = useState(true);

  return (
    <div className="d-flex flex-column rounded h-100">
      <div className="d-flex justify-content-between">
        <div className="flex-column justify-content-between">
          <div className="fw-bolder text-dark w-100 ms-1 fs-title mb-0">
            {/* Financial Health */}
            Financial Performance Benchmark
          </div>
          <span className="description fs-desc ms-1">
            Overall strength of your institution based on your financial
            performance.
          </span>
        </div>
        <div
          className="ms-10 pdf-visiblity"
          style={{ zIndex: 1, position: "sticky" }}
        >
          <div className="d-flex flex-row">
            <div
              className="toggle-gauge me-1"
              onClick={() => setToggleButton(!toggleButton)}
              style={{
                backgroundColor: !toggleButton ? "#FFF" : "#619BF3",
              }}
            >
              <img
                alt="icon"
                src={
                  !toggleButton
                    ? exportimages.gauge_blue
                    : exportimages.gauge_white
                }
              />
            </div>
            <div
              className="toggle-trend"
              onClick={() => setToggleButton(!toggleButton)}
              style={{
                backgroundColor: toggleButton ? "#FFF" : "#619BF3",
              }}
            >
              <img
                alt="icon"
                src={
                  toggleButton
                    ? exportimages.trend_blue
                    : exportimages.trend_white
                }
              />
            </div>
            {/* <div class="ms-2 cursor-pointer">
              <div
                className={`d-flex justify-content-left ${!downloadBtnStatus ? "disabledbuttonDownload" : ""}`}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  downloadReport();
                }}
              >
                <img
                  alt="icon"
                  src={exportimages?.downloadIcon}
                  style={{ height: "3rem" }}
                />
              </div>
            </div> */}
            {/* <div
              // className={`d-flex justify-content-left ms-2 cursor-pointer ${!downloadBtnStatus ? "disabledbuttonDownload" : ""}`}
              className={`d-flex justify-content-left ms-2 cursor-pointer`}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                downloadPdf();
              }}
            >
              <img
                alt="icon"
                src={exportimages?.downloadIcon}
                style={{ height: "3rem" }}
              />
            </div> */}
            {/* <PDFDownloadLink document={<MyDoc />} fileName="somename.pdf">
              {({ blob, url, loading, error }) =>
                loading ? "Loading document..." : "Download now!"
              }
            </PDFDownloadLink> */}
          </div>
        </div>
      </div>
      <div className="graph-container align-content-end">
        {toggleButton ? (
          <GaugeChart showCohort={true} />
        ) : (
          <ForecastGraph
            forecastData={selectedFinancialTrend?.trend}
            type={BPM_KEY?.financial_health_score}
            showCohort={true}
          />
        )}
      </div>
    </div>
  );
};

const MyDoc = () => (
  <Document>
    <Page>
      <View>
        <Text>Detailed Action Plan</Text>
      </View>
    </Page>
  </Document>
);

export default FHSGraph;
